import dayjs from "dayjs";
import { useState } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Modal from "../../../myfin_v2/elements/Modal";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import CommonDatePicker from "../../../myfin_v2/elements/CommonDatePicker";
import { Button } from "../../../myfin_v2/elements/Button";
import commoncss from "../../../myfin_v2/css/common.module.css";
import { createKeyManagerialPerson, updateKeyManagerialPerson } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import swal from "sweetalert";


import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../../myfin_v2/assets/icons/calender.svg";

export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#f4faf5',
        borderColor: '#c2e6d1',
        color: '#b3c0bd',
        boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
        borderWidth: '1px',
        borderRadius: '10px',
        '&:hover': {
            borderColor: '#b3c0bd',
        },
        minHeight: '38px',
        height: '38px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0 8px',
        display: 'flex',
        alignItems: 'center',
    }),
    input: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        margin: 0,
        padding: 0,
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        fontSize: '14px',
        margin: 0,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4d6d64',
        fontSize: '14px',
        margin: 0,
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f5e9',
        borderRadius: '0.25rem',
        border: '1px solid #c2e6d1',
        width: 'fit-content',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#4d6d64',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            backgroundColor: '#c2e6d1',
            color: '#4f665f',
        },
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#1A4338',
        fontWeight: 400,
        ':hover': {
            color: '#1A4338',
            fontWeight: 400,
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            color: '#4f665f',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#ffffff',
        border: '1px solid #c2e6d1',
        borderRadius: '6px',
        boxShadow: '0 0 0 1px #c2e6d1',
        marginTop: '6px',
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        borderRadius: '6px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#f4faf5'
            : state.isFocused
                ? '#f8f9f9'
                : 'transparent',
        color: '#4f665f',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '14px',
        borderRadius: '8px',
        marginBottom: '4px',
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};

const KeyManagerialPersonsModal = ({ 
    handleClose, 
    data, 
    type, 
    investmentID, 
    refreshData, 
    companyId,
    onSuccess,
    onError 
}) => {
    const [name, setName] = useState(type === "edit" ? data?.name : "");
    const [designation, setDesignation] = useState(
        type === "edit" ? data?.designation : ""
    )
   const [appointmentDate, setAppointmentDate] = useState(
    type === "edit" && data?.dateOfAppointment
        ? dayjs(data.dateOfAppointment)
        : null
    );

    const [resignationDate, setResignationDate] = useState(
    type === "edit" && data?.dateOfResignation
        ? dayjs(data.dateOfResignation)
        : null
    );

    const [apiResponse, setApiResponse] = useState(null);
    const handleSubmit = async () => {
  try {
    const payload = {
      companyID: companyId,  
      name: name,
      designation: designation,
      dateOfAppointment: appointmentDate
        ? appointmentDate.format("DD-MM-YYYY")
        : "",
      dateOfResignation: resignationDate
        ? resignationDate.format("DD-MM-YYYY")
        : "",
    };

    console.log(payload);

    let response;

    if (type === "edit") {
      response = await updateKeyManagerialPerson(investmentID, data._id, payload);
    } else {
      response = await createKeyManagerialPerson(investmentID, payload);
    }

    if (response.status === 200) {
      if (onSuccess) {
          onSuccess(type === "edit" ? "Updated Successfully" : "Created Successfully");
      }
      refreshData();
      handleClose();
    }

  } catch (error) {
    console.error("Error saving Key Managerial Person:", error);
    const errorMsg = error?.response?.data?.error || error?.response?.data?.message || "Something went wrong ❌";
    if (onError) {
        onError(errorMsg);
    } else {
        swal("Error", errorMsg, "error");
    }
  }
};


    return(
        <>
            <Modal
                width="500px"
                title={type === "edit" ? "Edit Key Managerial Personnel" : "Add Key Managerial Personnel"}
                bodycss={commoncss.unsetPadding}
                headerActions={
                    <CloseIcon
                        className="clickable"
                        onClick={handleClose}
                    />
                }
                footerActions={
                    <>
                        <Button
                            btnColor={buttoncss.secondary}
                            label="Cancel"
                            onClick={handleClose}
                        />
                        <Button
                            btnColor={buttoncss.primary}
                            label={type === "edit" ? "Update" : "Add Key Managerial Personnel"}
                            onClick={handleSubmit}
                        />
                    </>
                }
            >

                <div className={commoncss.pd1530}>
                    <InputGroup
                        label="Name"
                        inputs={[
                        <>
                            <input
                                type="text"
                                placeholder="Enter name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                style={{ height: "37px", boxSizing: "border-box" }}
                            />
                        </>,
                        ]}
                    />
                    <InputGroup
                        label="Designation"
                        inputs={[
                        <>
                            <input
                                type="text"
                                placeholder="Enter designation"
                                value={designation}
                                onChange={(e) => setDesignation(e.target.value)}
                                style={{ height: "37px", boxSizing: "border-box" }}
                            />
                        </>,
                        ]}
                    />
                    <InputGroup
                        label="Date of Appointment"
                        inputs={[
                            <>
                                <CommonDatePicker
                                    value={appointmentDate ? appointmentDate.format("YYYY-MM-DD") : ""}
                                    onChange={(val) => setAppointmentDate(val ? dayjs(val) : null)}
                                    containerClass=""
                                    containerStyle={{ backgroundColor: "#f4faf5", border: "1px solid #c2e6d1", borderRadius: "10px", height: "37px", padding: "0 10px", boxShadow: "none", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                                    inputStyle={{ backgroundColor: "transparent", color: "#4d6d64", fontSize: "13px", height: "100%", width: "100%", border: "none", outline: "none", padding: 0 }}
                                />
                            </>,
                        ]}
                    />
                    <InputGroup
                        label="Date of Resignation"
                        inputs={[
                            <>
                                <CommonDatePicker
                                    value={resignationDate ? resignationDate.format("YYYY-MM-DD") : ""}
                                    onChange={(val) => setResignationDate(val ? dayjs(val) : null)}
                                    containerClass=""
                                    containerStyle={{ backgroundColor: "#f4faf5", border: "1px solid #c2e6d1", borderRadius: "10px", height: "37px", padding: "0 10px", boxShadow: "none", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                                    inputStyle={{ backgroundColor: "transparent", color: "#4d6d64", fontSize: "13px", height: "100%", width: "100%", border: "none", outline: "none", padding: 0 }}
                                />
                            </>,
                        ]}
                    />
                </div>
                
            </Modal>
        </>
    )

}

export default KeyManagerialPersonsModal;